import { type ReactNode } from 'react'
import EmailForm from './EmailForm'
import ThankYou from './ThankYou'
import {
  useEmailCaptureSubmit,
  type EmailCaptureTrackProps,
} from './useEmailCaptureSubmit'
import classes from './EmailCapture.module.scss'

type EmailCaptureProps = {
  className?: string
  trackProps?: EmailCaptureTrackProps
  thankYouText?: string
  children?: ReactNode
  buttonType?: 'primary' | 'secondary' | 'tertiary'
}

const EmailCapture = ({
  className = 'mc-theme-dark mc-bg-dark',
  trackProps,
  thankYouText,
  children,
  ...props
}: EmailCaptureProps) => {
  const { success, handleSubmit } = useEmailCaptureSubmit(trackProps)

  return (
    <section
      className='container mc-my-12 mc-pt-4 position-relative'
      data-testid='email-capture'
      id='email-capture'
    >
      <div className={className}>
        <div
          className={`position-absolute ${classes.thankYou} ${
            !success && classes.hidden
          }`}
        >
          <ThankYou descriptionText={thankYouText} />
        </div>
        <div className={success ? classes.hidden : ''}>
          <EmailForm onSubmit={handleSubmit} {...props}>
            {children as React.ReactElement}
          </EmailForm>
        </div>
      </div>
    </section>
  )
}

export default EmailCapture
